var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 95,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6 0H27.2V3.4H30.6V0Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 0H37.4V3.4H40.8V0Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 0H44.2V3.4H47.6V0Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 3.40002H27.2V6.80002H30.6V3.40002Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 3.40002H37.4V6.80002H40.8V3.40002Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 3.40002H40.8V6.80002H44.2V3.40002Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 3.40002H54.4V6.80002H57.8V3.40002Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 6.80005H27.2V10.2H30.6V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 6.80005H30.6V10.2H34V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 6.80005H34V10.2H37.4V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 6.80005H40.8V10.2H44.2V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 6.80005H44.2V10.2H47.6V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 6.80005H47.6V10.2H51V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 10.2H30.6V13.6H34V10.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 10.2H34V13.6H37.4V10.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 10.2H44.2V13.6H47.6V10.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 10.2H51V13.6H54.4V10.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 13.6H27.2V17H30.6V13.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 13.6H34V17H37.4V13.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 13.6H37.4V17H40.8V13.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 13.6H44.2V17H47.6V13.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 13.6H47.6V17H51V13.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 13.6H51V17H54.4V13.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 13.6H54.4V17H57.8V13.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 17H34V20.4H37.4V17Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 17H37.4V20.4H40.8V17Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 17H44.2V20.4H47.6V17Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 17H47.6V20.4H51V17Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 17H54.4V20.4H57.8V17Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 20.4H27.2V23.8H30.6V20.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 20.4H34V23.8H37.4V20.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 20.4H40.8V23.8H44.2V20.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 20.4H47.6V23.8H51V20.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 20.4H54.4V23.8H57.8V20.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 23.8H37.4V27.2H40.8V23.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 23.8H44.2V27.2H47.6V23.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 23.8H51V27.2H54.4V23.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 23.8H54.4V27.2H57.8V23.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 27.2H0V30.6H3.4V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 27.2H10.2V30.6H13.6V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 27.2H13.6V30.6H17V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 27.2H17V30.6H20.4V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 27.2H20.4V30.6H23.8V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 27.2H23.8V30.6H27.2V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 27.2H27.2V30.6H30.6V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 27.2H34V30.6H37.4V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 27.2H47.6V30.6H51V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 27.2H51V30.6H54.4V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 27.2H57.8V30.6H61.2V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 27.2H68V30.6H71.4V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 27.2H74.8V30.6H78.2V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 27.2H78.2V30.6H81.6V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 27.2H81.6V30.6H85V27.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 30.6H0V34H3.4V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80002 30.6H3.40002V34H6.80002V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 30.6H23.8V34H27.2V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 30.6H27.2V34H30.6V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 30.6H30.6V34H34V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 30.6H40.8V34H44.2V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 30.6H51V34H54.4V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 30.6H68V34H71.4V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 30.6H71.4V34H74.8V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 30.6H74.8V34H78.2V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 30.6H78.2V34H81.6V30.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80002 34H3.40002V37.4H6.80002V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 34H6.80005V37.4H10.2V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 34H13.6V37.4H17V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 34H17V37.4H20.4V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 34H20.4V37.4H23.8V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 34H23.8V37.4H27.2V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 34H44.2V37.4H47.6V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 34H47.6V37.4H51V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 34H51V37.4H54.4V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 34H68V37.4H71.4V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 34H71.4V37.4H74.8V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 34H81.6V37.4H85V34Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 37.4H0V40.8H3.4V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 37.4H6.80005V40.8H10.2V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 37.4H10.2V40.8H13.6V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 37.4H17V40.8H20.4V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 37.4H37.4V40.8H40.8V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 37.4H40.8V40.8H44.2V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 37.4H57.8V40.8H61.2V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 37.4H64.6V40.8H68V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 37.4H71.4V40.8H74.8V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 37.4H74.8V40.8H78.2V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 37.4H78.2V40.8H81.6V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 37.4H81.6V40.8H85V37.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 40.8H0V44.2H3.4V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 40.8H10.2V44.2H13.6V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 40.8H17V44.2H20.4V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 40.8H20.4V44.2H23.8V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 40.8H23.8V44.2H27.2V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 40.8H34V44.2H37.4V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 40.8H40.8V44.2H44.2V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 40.8H51V44.2H54.4V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 40.8H61.2V44.2H64.6V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 40.8H81.6V44.2H85V40.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 44.2H0V47.6H3.4V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 44.2H10.2V47.6H13.6V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 44.2H13.6V47.6H17V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 44.2H17V47.6H20.4V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 44.2H30.6V47.6H34V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 44.2H47.6V47.6H51V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 44.2H51V47.6H54.4V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 44.2H54.4V47.6H57.8V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 44.2H68V47.6H71.4V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 44.2H78.2V47.6H81.6V44.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 47.6H0V51H3.4V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80002 47.6H3.40002V51H6.80002V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 47.6H10.2V51H13.6V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 47.6H17V51H20.4V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 47.6H20.4V51H23.8V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 47.6H23.8V51H27.2V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 47.6H27.2V51H30.6V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 47.6H34V51H37.4V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 47.6H37.4V51H40.8V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 47.6H40.8V51H44.2V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 47.6H51V51H54.4V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 47.6H57.8V51H61.2V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 47.6H68V51H71.4V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 47.6H71.4V51H74.8V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 47.6H74.8V51H78.2V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 47.6H78.2V51H81.6V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 47.6H81.6V51H85V47.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 51H0V54.4H3.4V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 51H10.2V54.4H13.6V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 51H23.8V54.4H27.2V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 51H37.4V54.4H40.8V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 51H57.8V54.4H61.2V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 51H61.2V54.4H64.6V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 51H64.6V54.4H68V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 51H71.4V54.4H74.8V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 51H74.8V54.4H78.2V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 51H81.6V54.4H85V51Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 54.4H0V57.8H3.4V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 54.4H10.2V57.8H13.6V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 54.4H13.6V57.8H17V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 54.4H17V57.8H20.4V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 54.4H20.4V57.8H23.8V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 54.4H27.2V57.8H30.6V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 54.4H30.6V57.8H34V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 54.4H40.8V57.8H44.2V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 54.4H51V57.8H54.4V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 54.4H54.4V57.8H57.8V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 54.4H57.8V57.8H61.2V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 54.4H61.2V57.8H64.6V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 54.4H64.6V57.8H68V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 54.4H68V57.8H71.4V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 54.4H74.8V57.8H78.2V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 54.4H78.2V57.8H81.6V54.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 57.8H27.2V61.2H30.6V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 57.8H37.4V61.2H40.8V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 57.8H40.8V61.2H44.2V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 57.8H44.2V61.2H47.6V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 57.8H47.6V61.2H51V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 57.8H51V61.2H54.4V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 57.8H54.4V61.2H57.8V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 57.8H68V61.2H71.4V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 57.8H74.8V61.2H78.2V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 57.8H78.2V61.2H81.6V57.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 61.2H27.2V64.6H30.6V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 61.2H30.6V64.6H34V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 61.2H34V64.6H37.4V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 61.2H37.4V64.6H40.8V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 61.2H40.8V64.6H44.2V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 61.2H54.4V64.6H57.8V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 61.2H61.2V64.6H64.6V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 61.2H68V64.6H71.4V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 61.2H81.6V64.6H85V61.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 64.6H27.2V68H30.6V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 64.6H34V68H37.4V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 64.6H44.2V68H47.6V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 64.6H51V68H54.4V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 64.6H54.4V68H57.8V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 64.6H68V68H71.4V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 64.6H78.2V68H81.6V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 64.6H81.6V68H85V64.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 68H27.2V71.4H30.6V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 68H30.6V71.4H34V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 68H34V71.4H37.4V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 68H47.6V71.4H51V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 68H51V71.4H54.4V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 68H54.4V71.4H57.8V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 68H57.8V71.4H61.2V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 68H61.2V71.4H64.6V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 68H64.6V71.4H68V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 68H68V71.4H71.4V68Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 71.4H27.2V74.8H30.6V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 71.4H30.6V74.8H34V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 71.4H37.4V74.8H40.8V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 71.4H47.6V74.8H51V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 71.4H51V74.8H54.4V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 71.4H57.8V74.8H61.2V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 71.4H61.2V74.8H64.6V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 71.4H78.2V74.8H81.6V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 71.4H81.6V74.8H85V71.4Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 74.8H37.4V78.2H40.8V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 74.8H44.2V78.2H47.6V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 74.8H47.6V78.2H51V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 74.8H54.4V78.2H57.8V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2 74.8H57.8V78.2H61.2V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 74.8H68V78.2H71.4V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 74.8H71.4V78.2H74.8V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 74.8H74.8V78.2H78.2V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 74.8H78.2V78.2H81.6V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 74.8H81.6V78.2H85V74.8Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 78.2H34V81.6H37.4V78.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 78.2H61.2V81.6H64.6V78.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 78.2H64.6V81.6H68V78.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 78.2H68V81.6H71.4V78.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 78.2H74.8V81.6H78.2V78.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 78.2H78.2V81.6H81.6V78.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 78.2H81.6V81.6H85V78.2Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 81.6H27.2V85H30.6V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 81.6H30.6V85H34V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 81.6H34V85H37.4V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 81.6H40.8V85H44.2V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 81.6H51V85H54.4V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 81.6H54.4V85H57.8V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 81.6H61.2V85H64.6V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 81.6H71.4V85H74.8V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 81.6H81.6V85H85V81.6Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.23 0H0V23.8H23.8V0H20.23ZM20.23 20.23H3.57V3.57H20.23V20.23Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.43 0H61.2V23.8H85V0H81.43ZM81.43 20.23H64.77V3.57H81.43V20.23Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.23 61.2H0V85H23.8V61.2H20.23ZM20.23 81.43H3.57V64.77H20.23V81.43Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 6.80005H6.80005V17.0001H17.0001V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 6.80005H68V17.0001H78.2V6.80005Z",
    fill: "#00B0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 68H6.80005V78.2H17.0001V68Z",
    fill: "#00B0E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.9796aeaa4f2cb02524ba61fc182ff2e5.svg";
export { ForwardRef as ReactComponent };